import "./homepage.css";

// Libraries
import React, { useEffect, useState } from "react";

import firebase from "../firebase";
import { database } from "../firebase";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import AdvancedFormat from "dayjs/plugin/advancedFormat";
import JSZip from "jszip";
import download from "downloadjs";
import { Base64 } from "js-base64";

// Components
import CertificatePreview from "./CertificatePreview";
import TemplateList from "./TemplateList";
import TopBarLinks from "./TopBarLinks";
import InputForm from "./InputForm";

// Fonts
import MontserratRegular from "../fonts/Montserrat/Montserrat-Regular.ttf";
import MontserratBold from "../fonts/Montserrat/Montserrat-Medium.ttf";
import MontserratLight from "../fonts/Montserrat/Montserrat-Light.ttf";
import Karumbi from "../fonts/Karumbi.ttf";

dayjs.extend(AdvancedFormat);

const dev = process.env.NODE_ENV === "development";

const convertFont = async (font) =>
  fetch(font)
    .then((r) => r.arrayBuffer())
    .then((b) => Base64.fromUint8Array(new Uint8Array(b)));

function Homepage() {
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState({
    names: [],
    date: dayjs(),
    duration: "",
    title: "",
    trainingId: "0",
    signatures: [],
    internal: true,
    employees: [],
    selEmployees: [],
  });

  async function fetchInfo() {
    const employeeRef = database.ref("employees");
    await employeeRef.get().then((s) => {
      setInput((prev) => {
        const tmp = { ...prev };
        return { ...tmp, employees: Object.values(s.val() ?? {}) };
      });
    });
    console.log(input.employees);
  }

  useEffect(() => {
    fetchInfo();
  }, []);

  const [template, setTemplate] = useState({});
  const [meta, setMeta] = useState({ items: {} });

  const transformInput = (key, value, meta) => {
    switch (key) {
      case "id":
        return `ID: ${input.date.format("YYYY[Q]Q")}${input.trainingId}${
          meta.employee
        }`;

      case "date":
        return value.format("DD.MM.YYYY");

      default:
        return value?.toString();
    }
  };

  const handlePrint = async () => {
    setLoading(true);

    try {
      const internal = input.internal;

      const zip = new JSZip();

      const mstR = await convertFont(MontserratRegular),
        mstB = await convertFont(MontserratBold),
        mstL = await convertFont(MontserratLight),
        karumbi = await convertFont(Karumbi);

      const templateImg = document.querySelector("#template-image");

      const list = internal ? input.selEmployees : input.names;

      for (const employee of list) {
        const name = internal
          ? `${employee.firstName} ${employee.lastName}`
          : employee;

        console.log(employee);

        const pdf = new jsPDF({
          orientation: "landscape",
        });

        const centerX = pdf.internal.pageSize.width / 2,
          centerY = pdf.internal.pageSize.height / 2;

        pdf.addFileToVFS("Montserrat-Regular.ttf", mstR);
        pdf.addFont("Montserrat-Regular.ttf", "Montserrat", "normal");

        pdf.addFileToVFS("Montserrat-Bold.ttf", mstB);
        pdf.addFont("Montserrat-Bold.ttf", "Montserrat", "bold");

        pdf.addFileToVFS("Montserrat-Light.ttf", mstL);
        pdf.addFont("Montserrat-Light.ttf", "Montserrat", "normal", 300);

        pdf.addFileToVFS("Karumbi.ttf", karumbi);
        pdf.addFont("Karumbi.ttf", "Karumbi", "normal");

        pdf.addImage(
          templateImg,
          "PNG",
          0,
          0,
          pdf.internal.pageSize.width,
          pdf.internal.pageSize.height,
          "bg"
        );

        for (const [key, item] of Object.entries(meta.items)) {
          const p = item.parameters;

          if (item.type === "div") {
            pdf
              .setFont(
                p.font ?? "Montserrat",
                "normal",
                p.fontWeight ?? "normal"
              )
              .setFontSize(p.fontSize)
              .setTextColor(p.textColor)
              .text(
                transformInput(key, input[key] ?? name, {
                  employee: input.internal ? employee.id ?? "00" : "",
                }),
                p.centerX ? centerX : p.x,
                p.centerY ? centerY : p.y,
                {
                  align: p.centerX ? "center" : p.textAlign ?? "left",
                }
              );
          } else if (item.type === "img") {
            const image = new Image();

            image.src = input[key];

            pdf.addImage(
              image,
              p.centerX ? centerX : p.x,
              p.centerY ? centerY : p.y
            );
          }
        }

        let nextSignatureY;

        for (const signature of input.signatures) {
          const signatureImg = document.querySelector(
            `#signature-${signature.name}`
          );

          if (!signatureImg) continue;

          const sigHeight = (signatureImg.naturalHeight * 25.4) / 96;

          nextSignatureY ??= meta.signatureCoordinates.y - sigHeight;

          pdf.addImage(
            signatureImg,
            "PNG",
            meta.signatureCoordinates.x,
            nextSignatureY
          );

          nextSignatureY -= sigHeight;
        }

        const pdfBlob = pdf.output("blob", {
          filename: "certs.pdf",
        });

        zip.file(
          `${input.trainingId} | ${name.replace(
            " ",
            "_"
          )}_${input.title.replace(" ", "_")}.pdf`,
          pdfBlob
        );
      }

      zip.generateAsync({ type: "blob" }).then(function (content) {
        download(
          content,
          `${input.trainingId} | Certificates-${input.title.replace(
            " ",
            "_"
          )}.zip`
        );
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const signout = () => {
    firebase.auth().signOut();
  };

  var name = input.names[0];
  if (input.selEmployees[0] && input.internal) name = `${input.selEmployees[0].firstName} ${input.selEmployees[0].lastName}`;
  if (!name) name = "Lorem Ipsum";

  return (
    <div className="main">
      <div className="header">
        <div className="left"></div>
        <div className="Middle">
          <h1>Generatore certificati</h1>
        </div>
        <div className="right">
          <TopBarLinks signout={signout} />
        </div>
      </div>
      <div className="maincontainer">
        <div className="leftmost">
          <TemplateList templateChanger={setTemplate} />
        </div>
        <div className="middle">
          <CertificatePreview
            name={name}
            input={input}
            template={template}
            meta={meta}
            setMeta={setMeta}
          />
        </div>
        <div className="right">
          <div className="form">
            <InputForm
              input={input}
              setInput={setInput}
              template={template}
              handlePrint={handlePrint}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Homepage;
